module.exports = __webpack_public_path__ + "img/Person_mit_Sonderfunktion.2b4e294d.svg";